import store, { actions } from '../redux/store';

export const setLoading = (value) => {
  store.dispatch(actions.setLoading(value));
};

export const openLoading = () => {
  setLoading(true);
};

export const closeLoading = () => {
  setLoading(false);
};
